import Echo from 'laravel-echo'
import Pusher, { AuthorizerCallback } from 'pusher-js'
import axios from 'axios'

window.Pusher = Pusher

const isSecure = process.env.VUE_APP_REVERB_SCHEME === 'https'
const DEFAULT_WS_PORT = 6001
const DEFAULT_WSS_PORT = 443
const authEndpoint = process.env.VUE_APP_REVERB_AUTH_ENDPOINT

export function resolveReverbPort (value: string | undefined, secure: boolean): number {
  const port = value ? Number(value) : (secure ? DEFAULT_WSS_PORT : DEFAULT_WS_PORT)
  if (!Number.isInteger(port) || port <= 0 || port > 65535) {
    throw new Error('VUE_APP_REVERB_PORT bevat geen geldige poort.')
  }

  return port
}

export function createEcho (token?: string): Echo<'reverb' | 'null'> {
  if (!process.env.VUE_APP_REVERB_ENABLED || process.env.VUE_APP_REVERB_ENABLED === 'false') {
    return new Echo({
      broadcaster: 'null'
    })
  }
  const port = resolveReverbPort(process.env.VUE_APP_REVERB_PORT, isSecure)

  return new Echo({
    broadcaster: 'reverb',
    key: process.env.VUE_APP_REVERB_APP_KEY,
    wsHost: process.env.VUE_APP_REVERB_HOST,
    wsPort: isSecure ? DEFAULT_WS_PORT : port,
    wssPort: isSecure ? port : DEFAULT_WSS_PORT,
    forceTLS: isSecure,
    enabledTransports: ['ws', 'wss'],
    authEndpoint,
    auth: {
      headers: token
        ? { Authorization: token, Accept: 'application/json' }
        : {}
    },
    authorizer: (channel: { name: string }) => ({
      authorize: (socketId: string, callback: AuthorizerCallback) => {
        axios.post(authEndpoint, {
          socket_id: socketId,
          channel_name: channel.name
        }, {
          headers: {
            Authorization: token,
            Accept: 'application/json'
          }
        }).then((response) => {
          callback(null, response.data)
        }).catch(() => {
          callback(new Error('Broadcast authentication failed.'), null)
        })
      }
    })
  })
}
